exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/view-syllabus/view-syllabus.component.scss
// module id = ../../../../../src/app/parent/dashboard/pages/quonta-intelligence/view-syllabus/view-syllabus.component.scss
// module chunks = main